/** Підписи категорій істот для UI (фільтр раси). */
export const CREATURE_BUCKET_LABELS = {
    undead: 'Нежить',
    human: 'Люди',
    elf: 'Ельфи/Феї',
    beast: 'Звірі',
    monster: 'Монстри',
    abomination: 'Абомінації/Демони',
    construct: 'Конструкти',
    elemental: 'Елементалі',
    spirit: 'Духи',
    other: 'Інше',
};
//# sourceMappingURL=source.js.map